import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useNavigate } from 'react-router-dom'
import Aos from "aos";

function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);

  return (
    <div className="main-div">
      <Navbar />
      <div className="grid md:grid-cols-2 grid-cols-1 xl:gap-[211px] lg:gap-[40px] gap-[24px] xl:pt-[195px] lg:pt-[140px] md:pt-[100px] pt-[51px] xl:px-[100px] lg:px-[40px] px-[20px]">
        <h2 data-aos="fade-right" className="font-[500] font-sans md:text-left text-center md:text-[80px] text-[40px] md:leading-[79px] leading-[49px] text-[#1D1837] tracking-[-0.32px]">About GISUL, <br /> A Work Force </h2>
        <div>
          <p data-aos="fade-left" className="font-[400] font-sans md:text-[16px] text-[13px] md:leading-[27px] leading-[22px] text-[#4F5576] md:pb-[27px] pb-[39px]">
            GISUL, we believe in the power of people. As a dedicated and dynamic workforce, we are committed to delivering excellence through skill, integrity, and innovation. Our team is built on strong values, a collaborative spirit, and a passion for progress.
          </p>
          <div data-aos="fade-up" className="log-btn md:justify-start justify-center">
            <button className="get1" onClick={() => {
              const token = localStorage.getItem('GISUL_TOKEN')
              if (token) {
                navigate('/profile')
              } else {
                navigate('/singup')
              }
            }}>
              Get Started
              <br />
              <i className="bi bi-arrow-right"></i>
            </button>
            <button data-aos="fade-up" className="get2" onClick={() => navigate('/course')}>
              View Courses
              <br />
              <i className="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 items-end grid-cols-1 md:gap-[80px] gap-[29px] md:pt-[63px] pt-[18px] xl:px-[100px] lg:px-[40px] px-[40px] xl:pb-[130px] lg:pb-[80px] pb-[55px]">
        <div className="">
          <img data-aos="flip-up" src="/assets/home/vector2.svg" alt="vector2" />
        </div>
        <div className="">
          <h3 data-aos="fade-left" className="italic font-[400] font-dmserif md:pb-[70px] pb-0 xl:text-[100px] lg:text-[70px] text-[50px] xl:leading-[110px] lg:leading-[80px] leading-[50px] text-[#6953A3] tracking-[-0.32px] md:text-left text-center">Upskilling Accelerator
          </h3>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
